import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=161688b4&scoped=true"
import script from "./exam.vue?vue&type=script&lang=js"
export * from "./exam.vue?vue&type=script&lang=js"
import style0 from "./exam.vue?vue&type=style&index=0&id=161688b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161688b4",
  null
  
)

export default component.exports